import React, { useState,useContext, useEffect } from "react";
import { MenuItem, TextField, Button } from "@mui/material";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper
} from "@mui/material";
import { toast } from "react-toastify";
import axios from "axios";
import baseUrl from "../../../../BaseURL";
import { ContextData } from "../../../../context/Context";
import PopUpDialug from "../../../home/PopUpDialug";
import PopupDialog from "../../../PopupDialog/PopupDialog";
 

function AddDocument() {


  // State for form inputs
  const [formData, setFormData] = useState({
    document_type_name: "",
    resdentialType:"",
    documentType:"",
    document_for:"",
    loan_category: "n/a",
    upload_for: "n/a",
    visibility:"n/a",
    instrct: "",
  });
  const [DocumentsList, setDocumentsList] = useState(null);
  const [Reload,setReload] = useState(true)
  const{accesstoken} = useContext(ContextData)
  // Handler for input changes
  const handleChange = (e) => {

    const { name, value } = e.target;
    
    setFormData({
      ...formData,
      [name]: value,
    });


  };


  // Handler for file input change
  const handleSubmit = () => {



    // Check for empty fields
    const isEmptyField = Object.values(formData).every((value) => value === "");

    if (isEmptyField) {
      toast.error("Please fill out all fields");
    } else {
  
      axios.post(`${baseUrl}/auth/upload_doc`,formData,{
        withCredentials: true,
        headers: {
          Accept: "application/json",
           'authorization': `Bearer ${accesstoken}`
        },
      })
      .then((res) => {
     
        if(res.data.status){
          toast.success(res.data.textStatus)
            setFormData({

              document_type_name: "",
              resdentialType:"",
              documentType:"",
              document_for:"",
              loan_category: "n/a",
              upload_for: "n/a",
              instrct: "",

            })
          
            }
            setReload(!Reload)
           // setFormData({  unit: "" });
      })
      .catch((err) => {
        toast.error(err.message);
        setReload(!Reload)
        if (err) return console.log(err.message);
      });

    }


  };



  useEffect(() => {

    async function FetchData() {
      //  setLoader(true)

      try {
        const response = await axios.get(`${baseUrl}/auth/get_upload_doc`, {
          withCredentials: true,
          headers: {
             'Accept': "application/json",
            'authorization': `Bearer ${accesstoken}`
          },
        });
    
        setDocumentsList(response.data);
      
      } catch (err) {
        if (err) console.log(err.message);
        // setLoader(false)
      }
    }
    FetchData();

  },[Reload]); 



  const DeleteDoc = async(token) =>{


    try {
      const response = await axios.delete(`${baseUrl}/auth/delete_upload_doc/${token}`, {
        withCredentials: true,
        headers: {
           'Accept': "application/json",
          'authorization': `Bearer ${accesstoken}`
        },
      });
  
      toast.warn(response.data.textStatus);
      setReload(!Reload)
    
    } catch (err) {
      if (err) console.log(err.message);
      setReload(!Reload)
      // setLoader(false)
    }


  }






  return (
    <div className="p-6 bg-gray-100 rounded-lg shadow-lg">
      <h2 className="text-xl font-semibold mb-4">Add Document</h2>
      <form className="space-y-4 text-left">
        <TextField
          label="Document Name"
          name="document_type_name"
          value={formData.document_type_name}
          onChange={handleChange}
          fullWidth
          variant="outlined"
          className="bg-white"
            inputProps={{ maxLength:  60}}
        />
        <TextField 
          select
          label="Resdential Type"
          name="resdentialType"
          value={formData.resdentialType}
          onChange={handleChange}
          fullWidth
          variant="outlined"
          className="bg-white"
        >
          <MenuItem value="indigene">Indigene</MenuItem>
          <MenuItem value="resident">Resident</MenuItem>
          <MenuItem value="both">Both</MenuItem>
        </TextField>


        <TextField
          select
          label="Document Type"
          name="documentType"
          value={formData.documentType}
          onChange={handleChange}
          fullWidth
          variant="outlined"
          className="bg-white"
        >
          <MenuItem value="undergraduate">Undergraduate</MenuItem>
          <MenuItem value="postgraduate">Postgraduate</MenuItem>
          <MenuItem value="both">Both</MenuItem>
        
        </TextField>

         <TextField
          select
          label="Document For"
          name="document_for"
          value={formData.document_for}
          onChange={handleChange}
          fullWidth
          variant="outlined"
          className="bg-white"
        >
          <MenuItem value="scholarship">Scholarship</MenuItem>
          <MenuItem value="loan">Loan</MenuItem>
        
        </TextField>
      
          
          {
             formData.document_for === "loan" && <>
             
         <TextField
          select
          label="Loan Category"
          name="loan_category"
          value={formData.loan_category}
          onChange={handleChange}
          fullWidth
          variant="outlined"
          className="bg-white"
        >

          <MenuItem value="studentloan">Student Loan</MenuItem>
          <MenuItem value="thirdparty">ThirdParty Loan</MenuItem>
        
        </TextField>


          <TextField
          select
          label="Upload For"
          name="upload_for"
          value={formData.upload_for}
          onChange={handleChange}
          fullWidth
          variant="outlined"
          className="bg-white"
           >
          <MenuItem value="applicant">Applicant</MenuItem>
          <MenuItem value="guarantor">Guarantor</MenuItem>
          <MenuItem value="sponsor">Sponsor</MenuItem>
        
          </TextField>


           <TextField
          select
          label="File visibility to Bank Reviewer"
          name="visibility"
          value={formData.visibility}
          onChange={handleChange}
          fullWidth
          variant="outlined"
          className="bg-white"
           >
         
          <MenuItem value="yes">Yes</MenuItem>
            <MenuItem value="no">No</MenuItem>
        
          </TextField>
             
             
             </>
          }
     



        <TextField
          label="Instruction"
          name="instrct"
          value={formData.instrct}
          onChange={handleChange}
          fullWidth
          variant="outlined"
          className="bg-white"
          multiline
          rows={4}
        />


        {/* Submit Button */}
        <Button onClick={handleSubmit} variant="contained" color="primary" className="w-full">
          Add
        </Button>
      </form> 


      <div className="list-con mt-3">
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow sx={{ background: "rgb(0, 24, 69)" }}>
                <TableCell
                  align="center"
                  sx={{ color: "white", fontWeight: "800" }}
                >
                  No.
                </TableCell>

                <TableCell
                  align="center"
                  sx={{ color: "white", fontWeight: "800" }}
                >
                  Required Document
                </TableCell>
                <TableCell
                  align="center"
                  sx={{ color: "white", fontWeight: "800" }}
                >
                  Required For
                </TableCell>
                <TableCell
                  align="center"
                  sx={{ color: "white", fontWeight: "800" }}
                >
                  Qualification Type
                </TableCell>

                  <TableCell
                  align="center"
                  sx={{ color: "white", fontWeight: "800" }}
                >
                  Document For
                </TableCell>
                
                <TableCell
                  align="center"
                  sx={{ color: "white", fontWeight: "800" }}
                >
                  Required Instruction
                </TableCell>
                

                <TableCell
                  align="center"
                  sx={{ color: "white", fontWeight: "800" }}
                >
                  Remove
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              { DocumentsList !== null && DocumentsList.map((item, index) => (
                <TableRow key={index}>
                  <TableCell align="center" sx={{ whiteSpace: "nowrap" }}>
                     {index + 1} 
                  </TableCell>
                  <TableCell align="center" sx={{ whiteSpace: "nowrap" }}>
                   {item.document_type_name}
                  </TableCell>
                  <TableCell align="center" sx={{ whiteSpace: "nowrap" }}>
                   {item.resdentialType}
                  </TableCell>
                 
                  <TableCell align="center" sx={{ whiteSpace: "nowrap" }}>
                   {item.documentType}
                  </TableCell>
                  
                    <TableCell align="center" sx={{ whiteSpace: "nowrap" }}>
                   {item.document_for}
                  </TableCell>

                  <TableCell align="center" sx={{ whiteSpace: "nowrap" }}>
                    <PopupDialog type="instruction" value={item.instrct} />
                  </TableCell>
                 
                  <TableCell align="center" sx={{ whiteSpace: "nowrap" }}>
                    <Button
                      className="Hover-"
                      // onClick={() => HanldeRemove(user.st_tokens)}
                      elevation={10}
                      sx={{
                        whiteSpace: "nowrap",
                        backgroundColor: "rgb(199, 1, 1)",
                      }}
                      size="small"
                      variant="contained"
                        onClick={()=>DeleteDoc(item.doc_token)}
                       >
                      Delete
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </div>
  );
}

export default AddDocument;
